import { FlexRow, MaterialIcon, StyledButton, StyledSearchBar, useModal } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useStyles } from '../../hooks/useStyles';
import { GpsType } from '../../types/device';
import GpsTypeSelect from '../shared/selects/GpsTypeSelect';
import StyledTooltip from '../ui/StyledTooltip';
import DeviceDetailModal from './modal/DeviceDetailModal';

type Props = {
  search?: string;
  onChangeSearch: (search?: string) => void;
  onReloadPage: () => void;
  gpsType?: GpsType;
  setGpsType: (gpsType?: GpsType) => void;
};
export function DevicesFiltersBar({ search, onChangeSearch, onReloadPage, gpsType, setGpsType }: Props) {
  const { css, theme } = useStyles();
  const { openModal, closeModal, showModal } = useModal();

  const resetFilters = () => {
    onChangeSearch(undefined);
    setGpsType(undefined);
  };

  return (
    <FlexRow
      classNames={css({
        justifyContent: 'space-between',
        width: '100%',
      })}
    >
      <FlexRow
        gap={theme.sizing.scale300}
        classNames={css({
          width: '50%',
        })}
      >
        <StyledSearchBar
          value={search ?? ''}
          onChange={onChangeSearch}
          clearable
          noMargin
        />
        <GpsTypeSelect
          selectedId={gpsType}
          onChangeId={setGpsType}
          selectMaxWidth={270}
          inline
        />
        <StyledTooltip
          content={'Restaurar filtros'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={resetFilters}
            kind="tertiary"
          >
            <MaterialIcon name={'autorenew'} />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <FlexRow gap={theme.sizing.scale300}>
        <StyledTooltip
          content={'Recargar tabla'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onReloadPage}
            kind="tertiary"
          >
            <MaterialIcon name={'refresh'} />
          </Button>
        </StyledTooltip>
        <StyledButton
          onClick={openModal}
          startEnhancer={
            <MaterialIcon
              name="add"
              size="xs-mini"
              color={theme.colors.contentInversePrimary}
            />
          }
        >
          Nuevo
        </StyledButton>
      </FlexRow>
      {showModal && (
        <DeviceDetailModal
          onClose={(updateTable) => {
            if (updateTable) {
              onReloadPage();
            }
            closeModal();
          }}
          isOpen={showModal}
        />
      )}
    </FlexRow>
  );
}
